<template>
  <div class="navtitle">
    <div v-if="logo === 'tongcheng'" class="logo-img">
      <img src="https://file.40017.cn/risk-manager/resolve-validate/logo.png">
    </div>
    <div v-if="logo === 'madaApp'" class="logo-img">
      <img src="https://file.40017.cn/risk-manager/resolve-validate/madaAppLogo.png">
    </div>
    <div class="left-icon" v-show="showBack">
      <svg t="1661248370764" @click="goBack" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
        p-id="5587" width="30" height="30">
        <path
          d="M401.066667 512l302.933333 302.933333-59.733333 59.733334L341.333333 571.733333 281.6 512 341.333333 452.266667l302.933334-302.933334 59.733333 59.733334L401.066667 512z"
          fill="#191f25" p-id="5588"></path>
      </svg>
      <!-- <svg t="1661248590536" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
        p-id="7328" width="30" height="30">
        <path
          d="M807.127074 186.990435c-7.695491 0-15.390982 2.898302-21.187585 8.794847L195.085692 786.539137c-11.693149 11.693149-11.693149 30.682022 0 42.375171 5.896545 5.896545 13.492094 8.794847 21.187585 8.794847 7.695491 0 15.390982-2.898302 21.187586-8.794847l590.753855-590.753855c11.693149-11.693149 11.693149-30.682022 0-42.375171-5.796604-5.896545-13.492094-8.794847-21.087644-8.794847z"
          p-id="7329" fill="#191f25"></path>
        <path
          d="M216.872926 186.490728c-7.695491 0-15.390982 2.898302-21.187585 8.794847-11.693149 11.693149-11.693149 30.682022 0 42.375171l590.653913 590.653913c5.896545 5.896545 13.492094 8.794847 21.187586 8.794847s15.390982-2.898302 21.187585-8.794847c11.693149-11.693149 11.693149-30.682022 0-42.37517l-590.653914-590.653914c-5.796604-5.896545-13.492094-8.794847-21.187585-8.794847z"
          p-id="7330" fill="#191f25"></path>
      </svg> -->
    </div>
    {{ title }}
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'navTitle',
  props: {
    title: String,
    showBack: {
      type: Boolean,
      default: true
    },
    logo: {
      type: String,
      default: 'tongcheng'
    },
    type: {
      type: String,
      default: 'h5'
    },
    url: {
      type: String,
      default: ''
    }
  },
  methods: {
    goBack() {
      // if (this.type === 'wx') {
      //   wx.miniProgram.redirectTo({ url: decodeURIComponent(this.url) })
      // } else {
        this.$router.go(-1)
      // }
    }
  }
}
</script>

<style scoped>
.navtitle {
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-bottom: 1px solid #d7d7d9;
  font-size: 18px;
  color: #111111;
  font-weight: bold;
  font-family: FiraSans-Bold;
  background-color: white;
  position: relative;
}

.left-icon {
  position: absolute;
  top: 50%;
  left: 16px;
  margin-top: -20px;
}

.logo-img {
  height: 10px;
  position: absolute;
  top: -20px;
  right: 10px;
}
.logo-img > img {
  height: 10px;
}
</style>
